// ---------------------------------------------------------------------------
// Financeiro · Contas bancárias — regras de leitura compartilhadas.
//
// `has_active_credential` foi acrescentado ao serializer da conta no adendo do
// handoff 0079, justamente para o front conseguir dizer "esta conta não emite"
// ANTES do submit, em vez de deixar o operador preencher a cobrança inteira e
// levar 422 (`bank_account_without_credential`).
// ---------------------------------------------------------------------------

// Uma conta só emite se estiver ATIVA e tiver chave de API ativa.
//
// ⚠️ Comparação com `!== false` de propósito: se o front subir antes do backend
// que traz o campo, `has_active_credential` vem `undefined` — e tratar ausência
// como "inapta" desabilitaria TODAS as contas e travaria a emissão inteira.
// Na dúvida, deixa passar: o backend continua sendo a autoridade e devolve o
// 422 com o code próprio, que a tela já trata.
export function isAptToIssue(account) {
   if (!account) return false;
   if (account.status && account.status !== 'active') return false;
   return account.has_active_credential !== false;
}

// Motivo da inaptidão, para exibir junto da opção/linha. Devolve null quando a
// conta está apta.
export function issuanceBlockReason(account) {
   if (!account) return null;
   if (account.status && account.status !== 'active') return 'conta inativa';
   if (account.has_active_credential === false) {
      return 'sem chave de integração ativa';
   }
   return null;
}
